import React from 'react'

export default function FlexGrow() {
    return (
        <div style={{
            flexGrow: '1'
        }}></div>
    )
}
